export default {
  props: {
    value: [Array],
  },
  data: () => ({
    array: [],
  }),
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        this.array = this.$eagleLodash.cloneDeep(this.value);
      },
    },
    array: {
      deep: true,
      handler() {
        if (this.$eagleLodash.isEqual(this.value, this.array)) return;
        this.$emit("input", this.array);
      },
    },
  },
}